(() => {
  if (window.__btkV2FounderStoryLoaded) return;
  window.__btkV2FounderStoryLoaded = true;

  const ROOT_SELECTOR = '[data-btk-v2-founder-story]';
  const SWIPE_THRESHOLD = 45;
  const SWIPE_DIRECTION_RATIO = 1.2;

  function initCarousel(root) {
    const carousel = root.querySelector('[data-btk-v2-founder-carousel]');

    if (!carousel) return;

    const track = carousel.querySelector(
      '.btk-v2-founder-story__transformation-track'
    );

    const slides = Array.from(
      carousel.querySelectorAll('[data-btk-v2-founder-slide]')
    );

    const dots = Array.from(
      carousel.querySelectorAll('[data-btk-v2-founder-dot]')
    );

    if (!slides.length || !track) return;

    let activeIndex = 0;
    let intervalId = null;
    let switchRequestId = 0;

    let touchStartX = 0;
    let touchStartY = 0;
    let isTouching = false;

    const autoRotate =
      root.getAttribute('data-auto-rotate') === 'true';

    const autoSpeed =
      Number(root.getAttribute('data-auto-speed')) || 5;

    function preloadSlideImages() {
      slides.forEach((slide) => {
        const image = slide.querySelector(
          '.btk-v2-founder-story__transformation-image'
        );

        if (!image) return;

        image.loading = 'eager';

        if (
          typeof image.decode === 'function' &&
          !image.complete
        ) {
          image.decode().catch(() => {});
        }
      });
    }

    function activateSlide(index) {
      activeIndex = index;

      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle(
          'is-active',
          slideIndex === activeIndex
        );
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;

        dot.classList.toggle('is-active', isActive);

        dot.setAttribute(
          'aria-selected',
          isActive ? 'true' : 'false'
        );
      });
    }

    function showSlide(index) {
      if (index < 0 || index >= slides.length) return;
      if (index === activeIndex) return;

      const requestId = ++switchRequestId;
      const nextSlide = slides[index];

      const nextImage = nextSlide.querySelector(
        '.btk-v2-founder-story__transformation-image'
      );

      function finishSwitch() {
        if (requestId !== switchRequestId) return;

        activateSlide(index);
      }

      if (
        !nextImage ||
        (nextImage.complete && nextImage.naturalWidth > 0)
      ) {
        finishSwitch();
        return;
      }

      if (typeof nextImage.decode === 'function') {
        nextImage
          .decode()
          .then(finishSwitch)
          .catch(() => {
            if (
              nextImage.complete &&
              nextImage.naturalWidth > 0
            ) {
              finishSwitch();
              return;
            }

            nextImage.addEventListener(
              'load',
              finishSwitch,
              { once: true }
            );

            nextImage.addEventListener(
              'error',
              finishSwitch,
              { once: true }
            );
          });

        return;
      }

      nextImage.addEventListener(
        'load',
        finishSwitch,
        { once: true }
      );

      nextImage.addEventListener(
        'error',
        finishSwitch,
        { once: true }
      );
    }

    function showNextSlide() {
      const nextIndex =
        activeIndex + 1 >= slides.length
          ? 0
          : activeIndex + 1;

      showSlide(nextIndex);
    }

    function showPreviousSlide() {
      const previousIndex =
        activeIndex - 1 < 0
          ? slides.length - 1
          : activeIndex - 1;

      showSlide(previousIndex);
    }

    function stopAutoRotate() {
      if (!intervalId) return;

      window.clearInterval(intervalId);
      intervalId = null;
    }

    function startAutoRotate() {
      stopAutoRotate();

      if (!autoRotate || slides.length <= 1) return;

      intervalId = window.setInterval(() => {
        showNextSlide();
      }, autoSpeed * 1000);
    }

    function handleTouchStart(event) {
      if (
        slides.length <= 1 ||
        event.touches.length !== 1
      ) {
        return;
      }

      const touch = event.touches[0];

      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      isTouching = true;

      stopAutoRotate();
    }

    function handleTouchEnd(event) {
      if (
        !isTouching ||
        !event.changedTouches.length
      ) {
        return;
      }

      const touch = event.changedTouches[0];

      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;

      const horizontalDistance = Math.abs(deltaX);
      const verticalDistance = Math.abs(deltaY);

      isTouching = false;

      const isHorizontalSwipe =
        horizontalDistance >= SWIPE_THRESHOLD &&
        horizontalDistance >
          verticalDistance * SWIPE_DIRECTION_RATIO;

      if (isHorizontalSwipe) {
        if (deltaX < 0) {
          showNextSlide();
        } else {
          showPreviousSlide();
        }
      }

      startAutoRotate();
    }

    function handleTouchCancel() {
      isTouching = false;
      startAutoRotate();
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.index);

        if (Number.isNaN(index)) return;

        showSlide(index);
        startAutoRotate();
      });
    });

    track.addEventListener(
      'touchstart',
      handleTouchStart,
      { passive: true }
    );

    track.addEventListener(
      'touchend',
      handleTouchEnd,
      { passive: true }
    );

    track.addEventListener(
      'touchcancel',
      handleTouchCancel,
      { passive: true }
    );

    carousel.addEventListener(
      'mouseenter',
      stopAutoRotate
    );

    carousel.addEventListener(
      'mouseleave',
      startAutoRotate
    );

    root.__btkV2FounderShowSlide = showSlide;

    root.__btkV2FounderDestroy = () => {
      stopAutoRotate();

      track.removeEventListener(
        'touchstart',
        handleTouchStart
      );

      track.removeEventListener(
        'touchend',
        handleTouchEnd
      );

      track.removeEventListener(
        'touchcancel',
        handleTouchCancel
      );

      carousel.removeEventListener(
        'mouseenter',
        stopAutoRotate
      );

      carousel.removeEventListener(
        'mouseleave',
        startAutoRotate
      );
    };

    preloadSlideImages();
    activateSlide(0);
    startAutoRotate();
  }

  function initSection(root) {
    if (
      !root ||
      root.dataset.btkV2FounderInitialized === 'true'
    ) {
      return;
    }

    root.dataset.btkV2FounderInitialized = 'true';

    initCarousel(root);
  }

  function initAllSections(scope = document) {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllSections();
    });
  } else {
    initAllSections();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAllSections(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      const root =
        event.target.matches?.(ROOT_SELECTOR)
          ? event.target
          : event.target.querySelector(ROOT_SELECTOR);

      if (
        root &&
        typeof root.__btkV2FounderDestroy === 'function'
      ) {
        root.__btkV2FounderDestroy();
      }
    }
  );

  document.addEventListener(
    'shopify:block:select',
    (event) => {
      const blockId =
        event.detail && event.detail.blockId;

      if (!blockId) return;

      const slide = document.querySelector(
        `${ROOT_SELECTOR} [data-btk-v2-founder-slide][data-block-id="${blockId}"]`
      );

      if (!slide) return;

      const root = slide.closest(ROOT_SELECTOR);

      if (
        !root ||
        typeof root.__btkV2FounderShowSlide !== 'function'
      ) {
        return;
      }

      const index = Number(slide.dataset.index);

      if (Number.isNaN(index)) return;

      root.__btkV2FounderShowSlide(index);
    }
  );
})();